module.exports = {
  "country": "DK",
  "artist": "Rollo & King",
  "song": "Never Ever Let You Go",
  "year": "2001",
  "place": "2",
  "spotify": "7mx6IZujrnfHLBmqcIOxIe"
};